module.exports = __webpack_public_path__ + "img/d70c09e55b9d43fb80f4b21d56347d17-1440.351ed988.jpg";